import { getCurrentUser } from '@/utils/index';

const PREVIEW_USERNAME = 'aim120';

export function isSitesBuilderPreviewUser(user = getCurrentUser()) {
  return String((user && user.un) || '').trim().toLowerCase() === PREVIEW_USERNAME;
}
